import { Assets } from "../../../../utils/Assets";
import { FormConfig, FormFieldType } from "../../../components/form/formTypes";

export const formHelpConfig: Record<string, string> = {
  text: "topic.help",
  image: Assets.topicPreview,
};

const statusOptions: Record<string, string> = {
  draft: "topic.status.draft",
  available: "topic.status.available",
  unavailable: "topic.status.unavailable",
};

const testimonyFormConfig: FormConfig[] = [
  {
    name: "title",
    label: "testimony.field.title",
    placeholder: "testimony.field.title",
    type: FormFieldType.Text,
  },
  {
    name: "subtitle",
    label: "testimony.field.subtitle",
    placeholder: "testimony.field.subtitle",
    type: FormFieldType.Text,
  },
  {
    name: "description",
    label: "testimony.field.description",
    placeholder: "testimony.field.description",
    type: FormFieldType.Text,
  },
  {
    name: "status",
    label: "testimony.field.status",
    placeholder: "testimony.field.status",
    type: FormFieldType.Select,
    settings: {
      options: statusOptions,
    },
  },
  {
    name: "image",
    label: "testimony.field.image",
    placeholder: "testimony.field.image",
    type: FormFieldType.Image,
    settings: {
      format: 1.25,
    },
  },
  {
    name: "videoLink",
    label: "testimony.field.videoLink",
    placeholder: "testimony.field.videoLink",
    type: FormFieldType.Text,
  },
  {
    name: "text",
    label: "testimony.field.text",
    placeholder: "testimony.field.text",
    type: FormFieldType.RichText,
  },
  {
    name: "tags",
    label: "testimony.field.tags",
    placeholder: "testimony.field.tags",
    type: FormFieldType.List,
  },
  {
    name: "keywords",
    label: "testimony.field.keywords",
    placeholder: "testimony.field.keywords",
    type: FormFieldType.List,
  },
  {
    name: "comments",
    label: "testimony.field.comments",
    placeholder: "testimony.field.comments",
    type: FormFieldType.Textarea,
  },
];

export default testimonyFormConfig;
